"use strict";

module.exports = function () {
  return this.opts.childRow || this.$scopedSlots.child_row;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/has-child-row.js
// module id = 1581
// module chunks = 61